<template>
  <el-drawer
    :visible.sync="drawerVisible"
    direction="rtl"
    size="960px"
    :with-header="false"
    class="task-detail-drawer"
  >
    <div v-loading="detailLoading" class="drawer-shell">
      <div class="drawer-head">
        <span>任务处理、上传与审计详情</span>
        <el-button type="text" icon="el-icon-close" @click="drawerVisible = false" />
      </div>

      <div class="drawer-body">
        <div class="summary-grid">
          <div v-for="item in summaryCards" :key="item.label" class="summary-card">
            <div class="summary-label">{{ item.label }}</div>
            <div class="summary-value">{{ item.value }}</div>
          </div>
        </div>

        <div class="section-title">源素材实际参数与规则快照</div>
        <div class="code-box" v-if="detailData">
          <div>源文件：{{ detailData.plan.fileName }}</div>
          <div>源参数：{{ detailData.plan.srcParam }}</div>
          <div>处理方式：{{ detailData.plan.processMode }}</div>
          <div>输出要求：{{ detailData.plan.outputReq }}</div>
          <div>替换位置：{{ detailData.plan.replacePosition }}</div>
        </div>

        <div class="section-title">完整冻结规则快照（{{ detailData.rules.length }}类）</div>
        <el-table
          :data="detailData ? detailData.rules : []"
          border
          size="mini"
          :header-cell-style="{ backgroundColor: '#FAFAFA', textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column prop="categoryName" label="规则分类" min-width="180" show-overflow-tooltip />
          <el-table-column prop="cfgContent" label="配置内容" min-width="280" show-overflow-tooltip />
        </el-table>
        <div class="section-title">输出文件清单</div>
        <el-table
          :data="detailData ? detailData.outputs : []"
          border
          size="mini"
          :header-cell-style="{ backgroundColor: '#FAFAFA', textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column prop="itemNo" label="序号" width="60" />
          <el-table-column prop="fileName" label="文件名" min-width="180" show-overflow-tooltip />
          <el-table-column prop="type" label="类型" min-width="120" />
          <el-table-column label="尺寸" min-width="120">
            <template slot-scope="{ row }">
              {{ row.width }}×{{ row.height }}
            </template>
          </el-table-column>
          <el-table-column prop="fileSize" label="容量" min-width="100" />
          <el-table-column prop="fileFormat" label="格式" min-width="80" />
          <el-table-column prop="fileHash" label="哈希" min-width="180" show-overflow-tooltip />
          <el-table-column prop="replacePosition" label="替换位置" min-width="140" show-overflow-tooltip />
          <el-table-column prop="validationStatus" label="校验" min-width="90">
            <template slot-scope="{ row }">
              <span class="status-ok">{{ row.validationStatus }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="drawer-foot">
        <!-- <el-button type="primary" @click="$emit('preview')">预览处理结果</el-button> -->
        <el-button @click="drawerVisible = false">关闭</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'TaskDetailDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    taskDetail: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      detailData: null,
      detailLoading: false
    }
  },
  watch: {
    visible (value) {
      if (value) {
        this.getTaskDetail()
      }
    },
    taskDetail: {
      handler () {
        if (this.visible) {
          this.getTaskDetail()
        }
      },
      deep: false
    }
  },
  mounted () {
    if (this.visible) {
      this.getTaskDetail()
    }
  },
  computed: {
    drawerVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    summaryCards () {
      if (!this.detailData) return []
      return [
        { label: '任务编号', value: this.detailData.subTaskNo },
        { label: '父批次', value: this.detailData.parentTaskNo },
        { label: '平台组/店铺', value: `${this.detailData.groupName}/${this.detailData.storeName}` },
        { label: '商品/平台商品编码', value: `${this.detailData.modelName}/${this.detailData.goodsCode}` },
        { label: '状态', value: this.detailData.status },
        { label: '重试次数', value: this.detailData.retryCount },
        { label: '冻结规则版本', value: this.detailData.frozenVersion },
        { label: '任务发起人', value: this.detailData.initiator },
        { label: '回读结果', value: this.detailData.readBackResult },
        { label: '结果说明', value: this.detailData.resultDesc }
      ]
    }
  },
  methods: {
    async getTaskDetail () {
      if (!this.taskDetail || !this.taskDetail.id) return
      this.detailLoading = true
      this.detailData = null
      try {
        const res = await this.$q.newProduct.imageTaskGetTaskDetail({
          params: {
            subTaskId: this.taskDetail.id
          }
        })
        this.detailData = res.data
      } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.drawer-shell
  height 100%
  display flex
  flex-direction column

.drawer-head,
.drawer-foot
  flex 0 0 auto
  display flex
  align-items center
  justify-content space-between
  padding 14px 20px
  background #fff
  border-bottom 1px solid #ebeef5

.drawer-foot
  border-top 1px solid #ebeef5
  border-bottom 0
  justify-content flex-end
  gap 12px

.drawer-body
  flex 1 1 auto
  overflow auto
  padding 16px 20px
  background #f7f8fa

.summary-grid
  display grid
  grid-template-columns repeat(4, minmax(0, 1fr))
  gap 12px
  margin-bottom 16px

.summary-card
  background #fff
  border 1px solid #ebeef5
  border-radius 6px
  padding 12px

.summary-label
  color #909399
  font-size 12px
  margin-bottom 6px

.summary-value
  color #303133
  font-weight 600
  word-break break-all

.section-title
  font-size 14px
  font-weight 600
  margin: 14px 0 10px

.code-box
  white-space pre-line
  line-height 1.7
  padding 12px
  background #fff
  border 1px solid #ebeef5
  border-radius 6px
  color #606266

.status-ok
  color #67c23a

@media (max-width: 1200px)
  .summary-grid
    grid-template-columns repeat(2, minmax(0, 1fr))
</style>
